import {FormProvider, useForm} from 'react-hook-form';

import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


export default function PasswordForm({onSave}) {
  const appContext = useAppContext();

  const formMethods = useForm({
    defaultValues: {
      password: '',
      newPassword: '',
      confirmNewPassword: '',
    },
  });


  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    try {
      const rez = await appContext.api.patch('api/v1/users/updatepassword', {
        json: values,
        parseJson: true,
      });
      onSave(rez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row g-3">
          <div className="col-12">
            <FormText
              label="Current Password"
              name="password"
              required={true}
              type="password"
            />
          </div>
          <div className="col-12">
            <FormText
              label="New Password"
              name="newPassword"
              required={true}
              type="password"
            />
          </div>
          <div className="col-12">
            <FormText
              label="Confirm New Password"
              name="confirmNewPassword"
              required={true}
              type="password"
            />
          </div>
        </div>
        <div className="text-end col mt-3">
          <FormError />
          <FormSubmit
            key="save"
            className="btn btn-lg btn-outline-light bg-black text-white"
          >
            Save
          </FormSubmit>
        </div>
      </form>
    </FormProvider>
  );
}
